import { AntDesign } from '@expo/vector-icons';
import { Box, Button, makeStyles, Typography } from '@material-ui/core';
import React, { useState, useEffect } from 'react';

export interface Props {
  parentCurrentDate: Date;
  parentSetCurrentDate: React.Dispatch<React.SetStateAction<Date>>;
  // parentIsThisMonth: React.Dispatch<React.SetStateAction<boolean>>;
}

const RankingSelectedMonth = (props: Props) => {
  const {
    parentCurrentDate,
    parentSetCurrentDate,
    // parentIsThisMonth
  } = props;
  const classes = useStyles();

  /************************************************
   * useState
   * *********************************************
   */

  // 表示日付データ（初期：現時点）
  const [currentDate, setCurrentDate] = useState(parentCurrentDate);
  // 表示月
  const [currentMonth, setCurrentMonth] = useState(currentDate.getMonth() + 1);

  // 前月フラグ
  const [isPreviousMonth, setIsPreviousMonth] = useState(false);
  // 今月フラグ
  const [isThisMonth, setIsThisMonth] = useState(true);

  /************************************************
   * useEffect
   * *********************************************
   */

  /************************************************
   * function
   * *********************************************
   */

  // 今月かどうかの判定
  useEffect(() => {
    const data = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    // 今月
    if (data.getFullYear() === currentYear && data.getMonth() === currentMonth) {
      setIsThisMonth(true);
      setIsPreviousMonth(false);
      // parentIsThisMonth(true);
    }
    // 前月
    else if (
      (data.getFullYear() === currentYear && data.getMonth() === currentMonth + 1) ||
      (data.getFullYear() === currentYear + 1 && data.getMonth() === 0 && currentMonth === 11)
    ) {
      setIsThisMonth(false);
      setIsPreviousMonth(true);
      // parentIsThisMonth(false);
    }
    // その他
    else {
      setIsThisMonth(false);
      setIsPreviousMonth(false);
      // parentIsThisMonth(false);
    }
  }, [currentDate]);

  /**日付操作****************************************/

  // 月表示を揃える
  const updateCurrentMonth = (date: Date) => {
    setCurrentMonth(date.getMonth() + 1);
  };

  // 「先月」ボタン：現在の年月から1か月前
  const handlePreviousMonth = () => {
    const data = new Date();

    data.setMonth(data.getMonth() - 1);

    setCurrentDate(data);
    parentSetCurrentDate(data);
    updateCurrentMonth(data);
  };

  // 「今月」ボタン：今月の年月
  const handleCurrentMonth = () => {
    const data = new Date();

    setCurrentDate(data);
    parentSetCurrentDate(data);
    updateCurrentMonth(data);
  };

  // ◀ ボタン：1か月戻す
  const handleDecrementMonth = () => {
    const data = new Date(currentDate);
    const currentMonth = data.getMonth();

    data.setMonth(currentMonth - 1);

    setCurrentDate(data);
    parentSetCurrentDate(data);
    updateCurrentMonth(data);
  };

  // ▶ ボタン：1か月進める
  const handleIncrementMonth = () => {
    const data = new Date(currentDate);

    data.setMonth(data.getMonth() + 1);

    setCurrentDate(data);
    parentSetCurrentDate(data);
    updateCurrentMonth(data);
  };

  /**スタイル操作****************************************/

  const isSP = window.innerWidth < 600;

  /************************************************
   * return
   * *********************************************
   */

  return (
    <>
      <Box className={classes.selectedMonthWrapper}>
        <Box className={classes.monthToggleState}>
          <Button
            variant={isPreviousMonth ? 'contained' : 'outlined'}
            color={isPreviousMonth ? 'primary' : 'default'}
            onClick={handlePreviousMonth}
            style={{ fontSize: '0.9rem' }}
            size="small"
          >
            先月
          </Button>
          <Button
            variant={isThisMonth ? 'contained' : 'outlined'}
            color={isThisMonth ? 'primary' : 'default'}
            onClick={handleCurrentMonth}
            style={{ fontSize: '0.9rem' }}
            size="small"
          >
            今月
          </Button>
        </Box>
        <Box className={classes.selectMonthWrapper}>
          <Button>
            <AntDesign name="caretleft" size={24} color="black" onClick={handleDecrementMonth} />
          </Button>
          <Typography className={classes.selectMonth}>{currentMonth}月</Typography>
          <Button>
            <AntDesign name="caretright" size={24} color="black" onClick={handleIncrementMonth} />
          </Button>
        </Box>
      </Box>
    </>
  );
};

/************************************************
 * style
 * *********************************************
 */
const useStyles = makeStyles({
  selectedMonthWrapper: {
    margin: '5vh 0 2vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  monthToggleState: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end',
  },
  selectMonthWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  selectMonth: {
    width: '60px',
    textAlign: 'center',
    fontSize: '1.5rem',
    '@media (min-width: 600px)': {
      width: '75px',
      fontSize: '2rem',
    },
  },
});

export default RankingSelectedMonth;
